import { Box, FlexBox } from "../../primitives";
import { styled } from "../../../stitches.config";

export const ContentWrapper = styled(FlexBox, {
  gap: 10,
  alignItems: "center",
  justifyContent: "space-between",
});

export const ConditionWrapper = styled("button", {
  all: "unset",
  padding: 10,
  border: "1px solid #166534",
  display: "flex",
  flexDirection: "column",
  gap: 10,
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  cursor: "pointer",
  variants: {
    isSelected: {
      true: {
        background: "#166534",
      },
      false: { background: "white" },
    },
    isDisabled: {
      true: {
        boxShadow: "0 0 8px 3px rgba(255, 0, 0, 0.7)",
        cursor: "not-allowed",
      },
    },
  },
});

export const ConditionCodeText = styled(Box, {
  fontWeight: 700,
  textShadow: "1px 1px 2px rgba(0, 0, 0, 1)",
  fontSize: 18,
});

export const HotKeyText = styled(Box, {
  textTransform: "uppercase",
  fontWeight: "bold",
  variants: {
    isSelected: { true: { color: "white" }, false: { color: "$primary" } },
  },
});

export const Group = styled(FlexBox, {
  gap: 10,
  marginTop: 20,
  flexWrap: "wrap",
  justifyContent: "center",
});
